export default __webpack_public_path__ + "static/media/151-book-bag.0ca3ffd8.png";